import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTrustRuleApplications } from "./api";
import type { TrustRuleApplicationResponse } from "./api";

// Read-only история применений правил для секции «История».
export function useTrustRuleApplications(): UseQueryResult<
  TrustRuleApplicationResponse[],
  Error
> {
  return useOrgScopedQuery<TrustRuleApplicationResponse[]>({
    key: ["trustRuleApplications"],
    queryFn: () => fetchTrustRuleApplications(),
    retry: false,
  });
}
